import type { FC } from 'react';

import { Box } from '@mui/material';
import { components } from 'react-select';

import type { SingleValueProps } from 'react-select';
import type { OptionType } from 'shared/ui-kit';

interface CustomSingleValueProps extends SingleValueProps<OptionType> {}

const SingleValue: FC<CustomSingleValueProps> = ({ children, ...props }) => {
  return (
    <components.SingleValue {...props}>
      <Box component={'span'} pt={'2px'} id="selectedValue">
        {children}
      </Box>
    </components.SingleValue>
  );
};

export default SingleValue;
